module.exports = __webpack_public_path__ + "img/table.9d2f132f.png";